module.exports = "/work-site/img/future_weather.4add22a3.png";